export default __webpack_public_path__ + "static/media/powerby.8415c0b8.png";